<template>
  <div class="c-accordion">
    <input type="checkbox" class="c-parts-accordion-input" v-model="isOpenLocal" :id="`chapter${partId}`" @change="playSound()">
    <div class="c-accordion__cont c-parts-accordion-content">
      <ul class="c-question">
        <li v-for="chapter in chapters" :ref="(el) => {chapterRef = el}"
            :class="{'c-question__item':true, 'c-question__item--clear':isAnimated(chapter.id)}">
          <span class="c-parts-homework -right" v-if="homeworkChapter(chapter.id)">宿題</span>
          <router-link :to="{ name: 'chapter', params: { chapter_id: chapter.id } }" name="S3-1-part-btn">
            <div class="c-question-block c-question-block--rika c-question-block--link -rika">
              <div class="c-question-block__inner">
                <div class="c-question-block__box">
                  <div class="c-question-block__box__chapter">
                    <span class="c-parts-label -chapter"><span class="number">{{chapter.index_label}}</span></span>
                    <div class="title"><markdown-view :rawText="chapter.title" :souruby="isSouruby"></markdown-view></div>
                  </div>
                  <div class="c-question-block__box__inner">
                    <progress-bar :ref="(el) => {progressBarRef = el}"
                      :percentage="getPercentage(chapter.id)">
                    </progress-bar>
                    <textbook-page-number :page-number-range="chapter.textbook_page_range" v-if="chapter.textbook_page_range">
                      {{chapter.textbook_page_range}}
                    </textbook-page-number>
                  </div>
                </div>
                <star-medal
                  :number-of-star-medal="getStarMedal(chapter.id)">
                </star-medal>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="c-accordion__btn c-parts-accordion-btn">
      <div class="c-accordion__btn__inner">
        <div class="c-accordion__btn__inner__box" name="S3-1-accordion-btn">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted, watch} from "vue";
  import {IChapter, IChapterProgress, IHomeworkQuestionSet} from "@/consts/interfaces";
  import AudioPlayer from '@/consts/sounds';
  import { useAccountStore } from '@/store/student/account_store';

  const audioPlayer = AudioPlayer.getInstance()
  const isOpenLocal = ref(false)
  const isAnimationLocal = ref(false)
  const chapterRef = ref(null)
  const progressBarRef = ref(null)
  const accountStore = useAccountStore()
  const props = withDefaults(
    defineProps<{
      partId: number;
      chapters?: IChapter[];
      isOpen?: boolean;
      chapterProgress?: {[id: string] : IChapterProgress} | any;
      isAnimation?: boolean;
      animationId?: number;
      loading?: boolean;
      isSouruby?: boolean;
      homeworkQuestionsets?: IHomeworkQuestionSet[]
    }>(),
    {
      chapters: () => [],
      isOpen: false,
      chapterProgress: () => {},
      isAnimation: false,
      animationId: 0,
      loading: false,
      isSouruby: false,
      homeworkQuestionsets: () => []
    }
  );

  const emit = defineEmits<{
    (e: 'update-chapter-progress'): void,
  }>()

  onMounted(() => {
    isOpenLocal.value =  props.isOpen
    isAnimationLocal.value = props.isAnimation
  })
  // chapterが宿題対象かチェック
  function homeworkChapter(chapter_id: number){
    return props.homeworkQuestionsets.some(h => chapter_id == h.chapter_id)
  }
  function showAnimation(chapterProgress){
    chapterRef.value?.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
    return new Promise((resolve, reject) => {
      if(!!chapterProgress){
        progressBarRef.value?.animate(chapterProgress.progress).then(()=>{
          emit("update-chapter-progress")
          if(chapterProgress.number_of_starmedal==3){
            setTimeout(() => {
              chapterRef.value?.classList.add("is-clear")
            },200)
          }else {
            chapterRef.value?.classList.remove("c-question__item--clear")
          }
          resolve(true)
        })
      }else{
        chapterRef.value?.classList.remove("c-question__item--clear")
        resolve(true)
      }
    })
  }
  function isAnimated(chapter_id){
    return isAnimationLocal.value && props.animationId == chapter_id;
  }
  function getPercentage(chapter_id){
    if(props.chapterProgress[chapter_id]){
      return props.chapterProgress[chapter_id].progress
    }
    else{
      return null
    }
  }
  function getStarMedal(chapter_id){
    if(props.chapterProgress[chapter_id]){
      return props.chapterProgress[chapter_id].number_of_starmedal
    }else{
      return 0
    }
  }
  function playSound() {
    if(accountStore.isSoundEnabled){audioPlayer.buttonSound().play()}
  }
  watch(
    () => props.isOpen,
    () => {
      isOpenLocal.value = props.isOpen
    }
  )
  watch(
    () => props.isAnimation,
    (value) => {
      isAnimationLocal.value = value
    }
  )
  defineExpose({showAnimation})
</script>